import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { resyncPush } from "../lib/push";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [me, setMe] = useState(null);
  const [sid, setSidState] = useState(localStorage.getItem("sid"));
  const [badges, setBadges] = useState({ notifications: 0, messages: 0, missions: 0 });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setMe(data);
      return data;
    } catch {
      setMe(false);
      return null;
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (me) resyncPush();
  }, [me?.user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const structures = me?.structures || [];
  const supportSid = me?.support?.structure_id;
  const current = (supportSid && structures.find((s) => s.id === supportSid)) || structures.find((s) => s.id === sid && !s.support) || structures.find((s) => !s.support) || null;

  const setSid = useCallback((id) => {
    localStorage.setItem("sid", id);
    setSidState(id);
  }, []);

  useEffect(() => {
    if (current && current.id !== sid && !current.support) setSid(current.id);
  }, [current, sid, setSid]);

  const cid = current?.id;
  const suspended = !!current?.suspended;
  const sp = useCallback((p) => `/s/${cid}${p}`, [cid]);
  const refreshBadges = useCallback(async () => {
    if (!cid || suspended) return;
    try {
      const { data } = await api.get(`/s/${cid}/badges`);
      setBadges(data);
    } catch (e) {
      console.warn("Badges indisponibles", e?.message);
    }
  }, [cid, suspended]);

  useEffect(() => {
    refreshBadges();
    const t = setInterval(refreshBadges, 20000);
    return () => clearInterval(t);
  }, [refreshBadges]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("sid");
    setMe(false);
  };

  const role = current?.role;
  const value = {
    me,
    setMe,
    user: me?.user,
    structures: structures.filter((s) => !s.support),
    current,
    sid: cid,
    setSid,
    role,
    isSupport: role === "support",
    isManager: role === "owner" || role === "co" || role === "support",
    isOwner: role === "owner",
    sp,
    reloadMe: load,
    badges,
    refreshBadges,
    logout,
  };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useApp = () => useContext(Ctx);
